const productData = [
	"品牌手机",
	"电脑平板",
    "办公设备",
	"游戏设备",
	"数码摄影"
]

export default productData